/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ['./src/**/*.{html,js,jsx,ts,tsx}'],
  theme: {
    extend: {
      width: {
        base: '27.5rem', // 440px base
        base2: '25rem', // 400px
        112: '28rem', // 448px (28 * 16)
        128: '32rem', // 512px (32 * 16)
        144: '36rem', // 576px (36 * 16)
        160: '40rem', // 640px (40 * 16)
        176: '44rem', // 704px (44 * 16)
        192: '48rem', // 768px (48 * 16)
      },
      height: {
        112: '28rem', // 448px (28 * 16)
        128: '32rem', // 512px (32 * 16)
        144: '36rem', // 576px (36 * 16)
        160: '40rem', // 640px (40 * 16)
        176: '44rem', // 704px (44 * 16)
        192: '48rem', // 768px (48 * 16)
      },
      minHeight: {
        11: '2.75rem', // Add 44px for lg Input/Select
      },
      keyframes: {
        'fade-in': {
          '0%': {
            opacity: '0',
            transform: 'translateY(-10px)',
          },
          '100%': {
            opacity: '1',
            transform: 'translateY(0)',
          },
        },
        pulseFade: {
          '0%': { opacity: '0' },
          '50%': { opacity: '1' },
          '100%': { opacity: '0' },
        },
        markerFade: {
          '0%': {
            opacity: '0',
          },
          '100%': {
            opacity: '1',
          },
        },
        markerFadeOut: {
          '0%': {
            opacity: '1',
          },
          '100%': {
            opacity: '0',
          },
        },
        highlight: {
          '0%': { backgroundColor: 'transparent' },
          '50%': { backgroundColor: 'rgb(186 230 253)' }, // sky-200
          '100%': { backgroundColor: 'transparent' },
        },
        shimmer: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(200%)' },
        },
        'slide-in-right': {
          '0%': {
            transform: 'translateX(100%)',
            opacity: '0',
          },
          '100%': {
            transform: 'translateX(0)',
            opacity: '1',
          },
        },
        'slide-out-right': {
          '0%': {
            transform: 'translateX(0)',
            opacity: '1',
          },
          '100%': {
            transform: 'translateX(100%)',
            opacity: '0',
          },
        },
        'slide-in-left': {
          '0%': {
            transform: 'translateX(-100%)',
            opacity: '0',
          },
          '100%': {
            transform: 'translateX(0)',
            opacity: '1',
          },
        },
        'slide-out-left': {
          '0%': {
            transform: 'translateX(0)',
            opacity: '1',
          },
          '100%': {
            transform: 'translateX(-100%)',
            opacity: '0',
          },
        },
        'slide-in-top': {
          '0%': { transform: 'translateY(-100%)' },
          '100%': { transform: 'translateY(0)' },
        },
        'slide-out-top': {
          '0%': { transform: 'translateY(0)' },
          '100%': { transform: 'translateY(-100%)' },
        },
        'slide-in-bottom': {
          '0%': { transform: 'translateY(100%)' },
          '100%': { transform: 'translateY(0)' },
        },
        'slide-out-bottom': {
          '0%': { transform: 'translateY(0)' },
          '100%': { transform: 'translateY(100%)' },
        },
        worm: {
          '0%, 100%': { transform: 'translateY(0px)' },
          '50%': { transform: 'translateY(-4px)' },
        },
        'thinking-dot': {
          '0%, 100%': { opacity: '0.3' },
          '50%': { opacity: '1' },
        },
        'ring-pulse': {
          '0%, 100%': { boxShadow: '0 0 0 0 rgba(239, 68, 68, 0.4)' },
          '50%': { boxShadow: '0 0 0 6px rgba(239, 68, 68, 0)' },
        },
        'text-shimmer': {
          '0%': { backgroundPosition: '200% 0' },
          '100%': { backgroundPosition: '-200% 0' },
        },
      },
      animation: {
        'fade-in': 'fade-in 0.3s ease-in-out',
        'pulse-fade': 'pulseFade 2s ease-in-out forwards',
        highlight: 'highlight 2s ease-in-out',
        'slide-in-right': 'slide-in-right 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        'slide-out-right': 'slide-out-right 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        'slide-in-left': 'slide-in-left 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        'slide-out-left': 'slide-out-left 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        'text-shimmer': 'text-shimmer 2.5s ease-in-out infinite',
        'slide-in-top': 'slide-in-top 300ms ease-out',
        'slide-out-top': 'slide-out-top 300ms ease-out',
        'slide-in-bottom': 'slide-in-bottom 300ms ease-out',
        'slide-out-bottom': 'slide-out-bottom 300ms ease-out',
        markerFade: 'markerFade 800ms cubic-bezier(0.4, 0, 0.2, 1)',
        markerFadeOut: 'markerFadeOut 800ms cubic-bezier(0.4, 0, 0.2, 1)',
        worm: 'worm 0.6s ease-in-out infinite',
        'thinking-dot': 'thinking-dot 1.2s ease-in-out infinite',
        'ring-pulse': 'ring-pulse 2s ease-in-out infinite',
      },
      colors: {
        'teal-900': '#005B38',
        'teal-800': '#007856',
        'teal-700': '#008865',
        'teal-600': '#009976',
        'teal-500': '#00A783',
        'teal-400': '#00B696',
        'teal-300': '#00C6A9',
        'teal-200': '#32D9C3',
        'teal-100': '#97E8DB',
        'teal-050': '#D6F6F1',
        'orange-900': '#cd5620',
        'orange-800': '#d96c23',
        'orange-700': '#e07a26',
        'orange-600': '#e78829',
        'orange-500': '#ec932c',
        'orange-400': '#efa23d',
        'orange-300': '#f1b25a',
        'orange-200': '#f5c887',
        'orange-100': '#f9ddb6',
        'orange-050': '#fcf2e2',
        'indigo-900': '#001ec0',
        'indigo-800': '#0029ca',
        'indigo-700': '#002ed0',
        'indigo-600': '#2335d9',
        'indigo-500': '#3739df',
        'indigo-400': '#6256e5',
        'indigo-300': '#8374e9',
        'indigo-200': '#a99cef',
        'indigo-100': '#ccc4f4',
        'indigo-050': '#ebe7fb',
        'purple-900': '#1900bc',
        'purple-800': '#400ac4',
        'purple-700': '#5113ca',
        'purple-600': '#611ed3',
        'purple-500': '#6c23d9',
        'purple-400': '#854ae0',
        'purple-300': '#9c6de6',
        'purple-200': '#b998ec',
        'purple-100': '#d5c2f3',
        'purple-050': '#efe6fa',
        'magenta-900': '#73005c',
        'magenta-800': '#9b0068',
        'magenta-700': '#b1006e',
        'magenta-600': '#c70075',
        'magenta-500': '#d8007a',
        'magenta-400': '#d92390',
        'magenta-300': '#dc53a6',
        'magenta-200': '#e386c0',
        'magenta-100': '#ecb6d9',
        'magenta-050': '#f7e2f0',
        'neutral-900': '#171717',
        'neutral-800': '#262626',
        'neutral-700': '#404040',
        'neutral-600': '#525252',
        'neutral-500': '#737373',
        'neutral-400': '#a3a3a3',
        'neutral-300': '#d4d4d8',
        'neutral-200': '#e5e5e5',
        'neutral-100': '#f5f5f5',
        'neutral-050': '#fafafa',
        'red-900': '#7f1d1d',
        'red-800': '#991b1b',
        'red-700': '#b91c1c',
        'red-600': '#dc2626',
        'red-500': '#ef4444',
        'red-400': '#f87171',
        'red-300': '#fca5a5',
        'red-200': '#fecaca',
        'red-100': '#fee2e2',
        'red-050': '#fef2f2',
        'green-900': '#14532d',
        'green-800': '#166534',
        'green-750': '#008236',
        'green-700': '#16a34a',
        'green-600': '#16a34a',
        'green-500': '#22c55e',
        'green-400': '#4ade80',
        'green-300': '#86efac',
        'green-200': '#bbf7d0',
        'green-100': '#dcfce7',
        'green-050': '#f0fdf4',
        'amber-900': '#78350f',
        'amber-800': '#92400e',
        'amber-700': '#b45309',
        'amber-600': '#d97706',
        'amber-500': '#f59e0b',
        'amber-400': '#fbbf24',
        'amber-300': '#fcd34d',
        'amber-200': '#fde68a',
        'amber-100': '#fef3c7',
        'amber-050': '#fffbeb',
        // Text Colors
        primary: '#262626',
        secondary: '#525252',
        tertiary: '#737373',
        link: '#1B5FA3',
        // Background Colors
        'level-1': '#fafafa',
        'level-2': '#f5f5f5',
        'level-3': '#e5e5e5',
        'level-4': '#d4d4d8',
        // shadcn-style tokens for Scout artifacts (STR-1004 spike). Namespaced
        // so they don't collide with `primary`/`secondary` above; the variables
        // are defined in globals.css.
        artifact: {
          foreground: 'hsl(var(--artifact-foreground) / <alpha-value>)',
          card: 'hsl(var(--artifact-card) / <alpha-value>)',
          'card-foreground': 'hsl(var(--artifact-card-foreground) / <alpha-value>)',
          primary: 'hsl(var(--artifact-primary) / <alpha-value>)',
          'primary-foreground': 'hsl(var(--artifact-primary-foreground) / <alpha-value>)',
          secondary: 'hsl(var(--artifact-secondary) / <alpha-value>)',
          'secondary-foreground': 'hsl(var(--artifact-secondary-foreground) / <alpha-value>)',
          muted: 'hsl(var(--artifact-muted) / <alpha-value>)',
          'muted-foreground': 'hsl(var(--artifact-muted-foreground) / <alpha-value>)',
          border: 'hsl(var(--artifact-border) / <alpha-value>)',
        },
      },
      maxHeight: {
        128: '32rem', // 512px
        144: '36rem', // 576px
        160: '40rem', // 640px
      },
      spacing: {
        128: '32rem', // 512px
        144: '36rem', // 576px
        160: '40rem', // 640px
        224: '56rem', // 896px (56 * 16 = 896)
      },
      components: {
        sizes: {
          sm: {
            height: '32px',
            padding: '8px 12px',
            fontSize: '12px',
            lineHeight: '16px',
          },
          md: {
            height: '36px',
            padding: '10px 14px',
            fontSize: '14px',
            lineHeight: '20px',
          },
          lg: {
            height: '40px',
            padding: '12px 16px',
            fontSize: '16px',
            lineHeight: '24px',
          },
        },
      },
      transitionTimingFunction: {
        drawer: 'cubic-bezier(0.4, 0, 0.2, 1)',
      },
      backgroundImage: {
        'table-split': 'linear-gradient(to right, white 18rem, #D6F6F1 18rem)',
        'table-split-hover':
          'linear-gradient(to right, #f5f5f5 18rem, #97E8DB 18rem)',
      },
    },
  },
  plugins: [require('@tailwindcss/container-queries')],
};
